import { render } from "./PainelGrafico.vue?vue&type=template&id=48d3c799&scoped=true"
import script from "./PainelGrafico.vue?vue&type=script&lang=js"
export * from "./PainelGrafico.vue?vue&type=script&lang=js"

import "./PainelGrafico.vue?vue&type=style&index=0&id=48d3c799&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d3c799"]])

export default __exports__